import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ProdottiComponent } from './prodotti.component';
import { ModalSchedaProdComponent } from 'src/app/pages/modal-scheda-prod/modal-scheda-prod.component';
import { SchedaProdottoModule } from 'src/app/pages/scheda-prodotto/scheda-prodotto.module';



@NgModule({
  declarations: [ProdottiComponent, ModalSchedaProdComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    NgbModule,
    FormsModule,
    RouterModule,
    SchedaProdottoModule
    
  ],
  exports: [
    ProdottiComponent
  ],
  entryComponents: [ModalSchedaProdComponent]
})
export class ProdottiModule { }
